/**
 * Created by SNOW on 2018.03.06.
 */
import functionalConfirmDialog from './main'
import confirmDialogComponent from './confirmDialog.vue'
const confirmDialog = {
  install: function (Vue) {
    Vue.component('confirmDialog', confirmDialogComponent)
    Vue.prototype.$confirmDialog = functionalConfirmDialog
  }
}
export default confirmDialog



// WEBPACK FOOTER //
// ./src/components/confirmDialog/index.js